import { FC } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { IconYaPay } from '../../icon/IconYaPay';
import { Flex } from '../../layout/Flex';
import { PersonalDiscountType } from '../../posts/types';
import { Typography, TypographyProps } from '../../typography/Typography';

export interface PayByConditionCaptionProps {
    type: PersonalDiscountType;
    color?: TypographyProps['color'];
}

export const PayByConditionCaption: FC<PayByConditionCaptionProps> = ({ type, color }) => {
    const t = useTranslation();

    if (type === 'yandex_pay') {
        return (
            <Flex direction="row" alignItems="center" spacing={0.25}>
                <Typography variant="caption" color={color}>
                    {t('Картой')}
                </Typography>
                <Typography as="span" variant="caption" color={color} display="inline-flex">
                    <IconYaPay size={14} />
                </Typography>
                <Typography variant="caption" color={color}>
                    {t('Пэй')}
                </Typography>
            </Flex>
        );
    }

    switch (type) {
        case 'ozon_card':
            return (
                <Typography variant="caption" color={color}>
                    {t('Картой Ozon')}
                </Typography>
            );
        case 'alfa_card':
            return (
                <Typography variant="caption" color={color}>
                    {t('Картой Альфа')}
                </Typography>
            );
        case 'vtb_card':
            return (
                <Typography variant="caption" color={color}>
                    {t('Картой ВТБ')}
                </Typography>
            );
        case 'wb_card':
            return (
                <Typography variant="caption" color={color}>
                    {t('WB Кошельком')}
                </Typography>
            );
        default:
            return null;
    }
};
